import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-judicial-enforcement',
  templateUrl: './judicial-enforcement.component.html',
  styleUrls: ['./judicial-enforcement.component.sass']
})
export class JudicialEnforcementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
